module.exports = __webpack_public_path__ + "img/3_19.879a44aa.png";